module.exports = __webpack_public_path__ + "static/media/intro-click.1df96f2e.wav";